exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contracts-div[data-v-1d0e30df] {\n  display: flex;\n  flex-direction: column;\n}\n.contracts-header[data-v-1d0e30df] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: ceter;\n  height: 75px;\n  padding: 16px 12px;\n}\n.contracts-body[data-v-1d0e30df] {\n  padding: 4px;\n}\n#accordion .card-header[data-v-1d0e30df]:hover {\n  background-color: #d1d0d0;\n  cursor: pointer;\n}\n.icon-box[data-v-1d0e30df] {\n  padding-top: 2px;\n  padding-right: 4px;\n  text-align: center;\n}\n.icon-box[data-v-1d0e30df]:hover {\n  cursor: pointer;\n}\n\n\n", ""]);

// exports
